const GET_IKEA_PRODUCTS = 'GetData';

class BaseAPI {
  constructor(config) {
    if (!config.baseURL) {
      throw new Error(
        'API endpoint not configured properly, please update environment files',
      );
    }

    this.baseURL = config.baseURL;
  }

  async request(endpoint, options) {
    const url = `${this.baseURL}${endpoint}`;
    const config = { ...options };

    try {
      const response = await fetch(url, config);

      if (response.ok) {
        return response.json();
      } else {
        throw new Error(
          `Server error ${response.status} - ${response.statusText}`,
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching IKEA products', error);
    }
  }
}

class IkeaAPI extends BaseAPI {
  constructor(config) {
    super(config);
  }
  getProducts(productPayload) {
    return this.request(`/${GET_IKEA_PRODUCTS}`, {
      method: 'POST',
      body: JSON.stringify(productPayload),
      headers: new Headers({
        'Content-type': 'application/json; charset=utf-8',
        'x-functions-key': `${process.env.GATSBY_IKEA_PRODUCTS_FUNCTION_KEY}`,
      }),
    });
  }
}

export default IkeaAPI;
